import UserService from "./UserService";
import { kichiriThatRejectsFailedRequests, checkIfUnauthorizedThenLogout } from "./KichiriService";

/**
 * Sends one Playbooks request and resolves to the server's answer. It uses the Kichiri client that
 * has no error interceptor, because once an interceptor is added Kichiri resolves a refused request
 * to undefined instead of rejecting, which loses the server's own words for why it refused. A
 * refused request rejects with the server's answer on error.response, after the same signed-out
 * check the shared client runs.
 *
 * @param {Object} params { operationId, body }
 * @return {Promise<Object>} the server's answer
 */
async function postToAgents({ operationId, body }) {
	const { authToken } = UserService.getUserData();
	try {
		const response = await kichiriThatRejectsFailedRequests.playbooks[operationId](body, {}, authToken);
		return response.data;
	} catch (error) {
		checkIfUnauthorizedThenLogout(error);
		throw error;
	}
}

export { postToAgents };
